<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/settings"></ion-back-button>
    </ion-buttons>
    <ion-title>Payment Processing</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

  <salonmonster-tap-retry
    *ngIf="errorOccurredWhileLoadingStats"
    (click)="onTapToReload()"
  ></salonmonster-tap-retry>

  <ng-container *ngIf="!isLoading && !errorOccurredWhileLoadingStats">
    <ion-row>
      <ion-col class="hidden-sm-down"></ion-col>

      <ion-col
        size="12"
        size-sm="12"
        size-md="8"
        size-lg="8"
        size-xl="8"
        *ngIf="!createdStripeAccount"
      >
        <ion-col size="12" *ngIf="!hasStripeAccount">
          <ion-list class="ion-padding">
            <img
              src="../../../assets/images/payment.png"
              class="smr-payment-image-size"
              alt=""
            />
            <h2 class="ion-text-center payment-title">
              salonMonster's integrated payment processing makes your life
              easier and makes you more money
            </h2>
            <p class="ion-text-center">
              In under 5 minutes you'll be able to accept payments in
              salonMonster and take deposits when client's book.
            </p>
            <ion-button
              color="primary"
              ng-reflect-color="primary"
              class="button button-md button-default center-block button-default-md button-md-primary payment-process-button"
              (click)="setupPaymentProcessing()"
            >
              Set up payment processing
            </ion-button>
            <ion-item class="ion-no-padding"></ion-item>
            <h5 class="ion-text-center ion-margin-bottom ion-margin-top">
              Low and transparent per transaction pricing. No setup fees or
              monthly fees.
            </h5>
            <ion-grid class="smr-payment-rates">
              <ion-row>
                <ion-col offset="4"><b>USA</b></ion-col
                ><ion-col><b>Canada</b></ion-col>
              </ion-row>
              <ion-row>
                <ion-col><b>Card Present</b></ion-col
                ><ion-col>2.6% + $0.10</ion-col><ion-col>2.65%</ion-col>
              </ion-row>
              <ion-row>
                <ion-col><b>Online / On file</b></ion-col
                ><ion-col>2.9% + $0.30</ion-col><ion-col>2.9% + $0.30</ion-col>
              </ion-row>
            </ion-grid>
          </ion-list>
          <ion-item class="ion-no-padding"></ion-item>
          <h5 class="ion-text-center ion-margin-bottom ion-margin-top">
            Attractive, easy to use hardware
          </h5>
          <img
            src="../../../assets/images/wise-pos-e-in-hand.png"
            alt="wise pos E"
            class="ion-padding smr-cardreader-image"
          />
          <ion-item class="ion-no-padding"></ion-item>
          <div class="ion-text-center ion-padding-bottom">
            <h4>Got questions?</h4>
            <ion-button
              (click)="showChat()"
              fill="outline"
              class="ion-margin-bottom"
              >Chat with us</ion-button
            >
          </div>
        </ion-col>
        <ion-col
          size="12"
          size-sm="12"
          size-md="8"
          size-lg="8"
          size-xl="8"
          *ngIf="hasStripeAccount"
        >
          <img
            src="../../../assets/images/payment.png"
            class="payment-image-size"
            alt=""
          />

          <ion-row class="margin-top-20">
            <ion-col>
              <ion-button
                color="primary"
                (click)="viewPayments()"
                ng-reflect-color="primary"
                class="center-block payment-process-button margin-top-20"
              >
                <span class="button-inner"> View your payments</span>
              </ion-button>
            </ion-col>
            <ion-col>
              <ion-button
                color="primary"
                (click)="viewPayouts()"
                ng-reflect-color="primary"
                class="center-block payment-process-button margin-top-20"
              >
                <span class="button-inner"> View your payouts</span>
              </ion-button>
            </ion-col>
            <ion-col>
              <ion-button
                color="primary"
                fill="outline"
                (click)="viewAccountSettings()"
                ng-reflect-color="primary"
                class="center-block payment-process-button margin-top-20"
              >
                <span class="button-inner"> View your account</span>
              </ion-button>
            </ion-col>
          </ion-row>
          <div id="container"></div>
          <ion-row>
            <ion-col size="12">
              <h3 class="ion-text-center ion-margin-top">Your card readers</h3>
            </ion-col>
            <ion-col size="12">
              <p *ngIf="!discoveringReader" class="ion-text-center">
                Locating card readers! This may take a minute.
              </p>
              <salonmonster-load-mask
                [ngClass]="'center-block'"
                *ngIf="!discoveringReader"
              ></salonmonster-load-mask>
            </ion-col>
            <ion-col
              size="12"
              *ngIf="discoveredReaders.length > 0 && discoveringReader && discoveredReaders[0] !== -1"
            >
              <ion-col
                *ngFor="let reader of discoveredReaders; let i = index"
                size="8"
                [ngClass]="'connectedTerminalBlock readerP400lBlock'"
              >
                <img
                  src="../../../assets/images/bbpos-wisepos-e.png"
                  class="cardReaderImage"
                  alt=""
                /><br />
                <span class="cardReaderSpan">BBPOS WisePOS E</span> <br />
                <span class="cardReaderSpan reader-serial-number"
                  >(S/N: {{reader.reader.serial_number}})</span
                ><br />
                <ion-button
                  *ngIf="!connectPushed[i]  && !reader.status"
                  (click)="connectCardReader(reader.reader, i)"
                  color="primary"
                  ng-reflect-color="primary"
                  class="ion-margin-top"
                >
                  <span class="button-inner">Connect</span>
                </ion-button>
                <ion-button
                  *ngIf="reader.status && !disconnectPush[i]"
                  (click)="disconnectReader(reader.reader, i)"
                  fill="outline"
                  ng-reflect-outline=""
                  class="button button-md button-default button-outline button-outline-md ion-margin-top"
                  style="
                    touch-action: pan-y;
                    user-select: none;
                    -webkit-user-drag: none;
                    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                  "
                >
                  <span class="button-inner">Disconnect</span>
                </ion-button>
                <div
                  *ngIf="(connectPushed[i] || disconnectPush[i]) && !cardReaderConnectError[i]"
                  class="mini-loading"
                >
                  <salonmonster-small-checkmark-loader
                    [completed]="readerConnectSuccessful[i] || readerDisconnectSuccessful[i]"
                  ></salonmonster-small-checkmark-loader>
                </div>
                <span *ngIf="cardReaderConnectError[i]">
                  <p
                    class="sm-error ion-text-center display-inline margin-left-10"
                  >
                    Oops! something went wrong
                  </p>
                </span>
              </ion-col>
              <ion-button
                (click)="checkCardReaders()"
                fill="outline"
                ng-reflect-outline=""
                class="button button-md button-outline button-outline-md center-block payment-process-button margin-top-50"
                style="
                  touch-action: pan-y;
                  user-select: none;
                  -webkit-user-drag: none;
                  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                "
              >
                <span class="button-inner">Search again</span>
              </ion-button>
            </ion-col>
            <ion-col
              size="12"
              *ngIf="discoveringReader && discoveredReaders.length === 0"
            >
              <p class="ion-text-center"><b>No card readers found.</b></p>
              <p class="ion-text-center">
                Please select "Connect a card reader".
              </p>
              <br />
              <ion-button
                (click)="checkCardReaders()"
                fill="outline"
                ng-reflect-outline=""
                class="button button-md button-outline button-outline-md center-block payment-process-button"
                style="
                  touch-action: pan-y;
                  user-select: none;
                  -webkit-user-drag: none;
                  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                "
              >
                <span class="button-inner">Search again</span>
              </ion-button>
            </ion-col>
            <ion-col>
              <ion-row>
                <ion-button
                  (click)="showCardReader()"
                  fill="outline="
                  ng-reflect-outline=""
                  class="button button-md button-outline button-outline-md center-block payment-process-button margin-top-20"
                  style="
                    touch-action: pan-y;
                    user-select: none;
                    -webkit-user-drag: none;
                    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                  "
                >
                  <span class="button-inner">Connect a card reader</span>
                </ion-button>

                <!-- <ion-button
                  fill="outline"
                  ng-reflect-outline=""
                  class="button button-md button-outline button-outline-md center-block payment-process-button margin-top-20"
                  style="
                    touch-action: pan-y;
                    user-select: none;
                    -webkit-user-drag: none;
                    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                  "
                >
                  <span class="button-inner">Order a new card reader</span>
                </ion-button> -->
              </ion-row>
              <ion-row>
                <ion-button
                  (click)="resetCardReader()"
                  fill="clear"
                  style="color: #ccc"
                  class="center-block"
                  >Reset card reader settings
                </ion-button>
              </ion-row>
            </ion-col>
            <ion-col
              size="12"
              *ngIf="discoveringReader && discoveredReaders[0] === -1"
            >
              <p class="ion-text-center">
                Oops, we had trouble discovering your card reader, please try
                again!
              </p>
              <ion-button
                (click)="checkCardReaders()"
                fill="outline"
                ng-reflect-outline=""
                class="center-block payment-process-button"
                style="
                  touch-action: pan-y;
                  user-select: none;
                  -webkit-user-drag: none;
                  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                "
              >
                <span class="button-inner">Search again</span>
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-col>
      <ion-col
        size="12"
        size-sm="12"
        size-md="8"
        size-lg="8"
        size-xl="8"
        *ngIf="createdStripeAccount"
      >
        <h2 class="ion-text-center payment-title">
          Payment account successfully created!
        </h2>
      </ion-col>
      <ion-col class="hidden-sm-down"></ion-col>
    </ion-row>
  </ng-container>
</ion-content>
